(() => {
  'use strict';

  // Register before Searchanise loads so the first request uses the chosen size.
  const url = new URL(window.location.href);
  if (!url.pathname.replace(/\/$/, '').endsWith('/pages/search-results-page') || url.searchParams.has('view')) return;

  const sizes = [15, 30, 50];
  const preferenceKey = 'rok-search-products-per-page';
  const validSize = (value) => sizes.includes(Number(value)) ? Number(value) : null;
  let savedSize;
  try { savedSize = sessionStorage.getItem(preferenceKey); } catch (_) { /* Storage is optional. */ }
  const pageSize = validSize(url.searchParams.get('per_page')) || validSize(savedSize) || 15;
  try { sessionStorage.setItem(preferenceKey, String(pageSize)); } catch (_) { /* URL still carries the selection. */ }

  let bound = false;
  let resultPage = 1;
  let totalResults = 0;
  const updatePagination = () => {
    const root = document.getElementById('snize_results');
    if (!root) return;
    const hasProducts = !!root.querySelector('.snize-product');
    root.classList.toggle('rok-sized-products', hasProducts);
    root.querySelector('.rok-search-pagination')?.remove();
    const control = root.querySelector('.rok-search-page-size');
    if (control) control.hidden = !hasProducts;
    const pageCount = Math.ceil(totalResults / pageSize);
    if (!hasProducts || pageCount < 2) return;

    const nav = document.createElement('nav');
    nav.className = 'rok-search-pagination';
    nav.setAttribute('aria-label', 'Search results pages');
    const addLink = (page, text, description) => {
      const link = document.createElement('a');
      const target = new URL(window.location.href);
      target.searchParams.set('page', String(page));
      target.searchParams.set('per_page', String(pageSize));
      link.href = target.href;
      link.textContent = text;
      link.setAttribute('aria-label', description || 'Page ' + page);
      if (page === resultPage) link.setAttribute('aria-current', 'page');
      nav.appendChild(link);
    };
    if (resultPage > 1) addLink(resultPage - 1, 'Previous', 'Previous page');
    const pages = [...new Set([1, resultPage - 1, resultPage, resultPage + 1, pageCount])]
      .filter((page) => page >= 1 && page <= pageCount).sort((a, b) => a - b);
    pages.forEach((page, index) => {
      if (index && page - pages[index - 1] > 1) {
        const gap = document.createElement('span');
        gap.textContent = '…';
        gap.setAttribute('aria-hidden', 'true');
        nav.appendChild(gap);
      }
      addLink(page, String(page));
    });
    if (resultPage < pageCount) addLink(resultPage + 1, 'Next', 'Next page');
    const status = document.createElement('span');
    status.className = 'rok-search-page-status';
    status.textContent = 'Page ' + resultPage + ' of ' + pageCount;
    nav.appendChild(status);
    const nativePagination = root.querySelector('.snize-pagination');
    if (nativePagination) nativePagination.after(nav);
    else root.appendChild(nav);
  };
  const addControl = () => {
    const header = document.querySelector('.snize-header');
    if (!header) return;

    if (!document.getElementById('rok-search-page-size-style')) {
      const style = document.createElement('style');
      style.id = 'rok-search-page-size-style';
      style.textContent = `
        .snize-header.rok-page-size-header {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 12px 20px;
        }
        .snize-header.rok-page-size-header .snize-search-results-header {
          flex: 1 1 240px; margin-bottom: 0;
        }
        .rok-search-page-size {
          display: flex; align-items: center; gap: 8px; flex: 0 0 auto;
          margin: 0; color: #333; font-size: 14px; line-height: 1.4;
        }
        .rok-search-page-size select {
          appearance: auto; width: 76px; min-height: 40px;
          padding: 6px 10px; border: 1px solid #767676; border-radius: 4px;
          background: #fff; color: #222; font: inherit; cursor: pointer;
        }
        .rok-search-page-size select:focus-visible {
          outline: 2px solid #252525; outline-offset: 3px;
        }
        #snize_results.rok-sized-products .snize-pagination,
        .rok-search-page-size[hidden] { display: none !important; }
        .rok-search-pagination {
          display: flex; justify-content: center; align-items: center; flex-wrap: wrap;
          gap: 8px; margin: 32px 0 16px; clear: both; width: 100%;
        }
        .rok-search-pagination a {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 44px; min-height: 44px; padding: 6px 12px;
          border: 1px solid #767676; border-radius: 4px;
          color: #222; background: #fff; text-decoration: none;
        }
        .rok-search-pagination a[aria-current="page"] {
          color: #fff; background: #222; border-color: #222;
        }
        .rok-search-pagination a:focus-visible {
          outline: 2px solid #252525; outline-offset: 3px;
        }
        .rok-search-page-status { flex-basis: 100%; text-align: center; margin-top: 4px; }
        @media (max-width: 480px) {
          .rok-search-page-size select { min-height: 44px; font-size: 16px; }
        }
      `;
      document.head.appendChild(style);
    }

    header.classList.add('rok-page-size-header');
    if (!header.querySelector('.rok-search-page-size')) {
      const label = document.createElement('label');
      label.className = 'rok-search-page-size';
      label.appendChild(document.createTextNode('Products per page'));
      const select = document.createElement('select');
      select.name = 'rok-products-per-page';
      sizes.forEach((size) => {
        const option = document.createElement('option');
        option.value = String(size);
        option.textContent = String(size);
        option.selected = size === pageSize;
        select.appendChild(option);
      });
      select.addEventListener('change', () => {
        const nextSize = validSize(select.value);
        if (!nextSize || nextSize === pageSize) return;
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('per_page', String(nextSize));
        nextUrl.searchParams.delete('page');
        try { sessionStorage.setItem(preferenceKey, String(nextSize)); } catch (_) { /* Optional preference. */ }
        window.location.assign(nextUrl.href);
      });
      label.appendChild(select);
      header.appendChild(label);
    }

    updatePagination();
  };

  const bind = () => {
    if (bound || !window.Searchanise || !window.Searchanise.$) return;
    bound = true;
    const $ = window.Searchanise.$;
    $(document).on('Searchanise.DataRequestBefore', (_event, type, params) => {
      if (type !== 'results') return;
      const requestedSize = Number(params.maxResults) || 15;
      const page = Math.floor((Number(params.startIndex) || 0) / requestedSize);
      params.maxResults = pageSize;
      params.startIndex = page * pageSize;
    });
    $(document).on('Searchanise.DataRequestEnd', (_event, type, params, data) => {
      if (type !== 'results') return;
      totalResults = Number(data.totalItems) || 0;
      resultPage = Math.floor((Number(params.startIndex) || 0) / pageSize) + 1;
    });
    $(document).on('Searchanise.ResultsUpdated', addControl);
    addControl();
  };

  document.addEventListener('Searchanise.Loaded', bind);
  bind();
})();
